import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appUrlValidator]'
})
export class UrlFormatDirective {
  private urlPattern = /^(https?:\/\/)?([\w-]+\.)+([a-zA-Z]{2,})(\/[\w-./?%&=]*)?$/;

  @Output() urlValidationStatus = new EventEmitter<boolean>();

  @HostListener('blur', ['$event.target.value']) onBlur(value: string) {
    const isValid = this.urlPattern.test(value.trim());
    this.urlValidationStatus.emit(isValid); // Emit validation result
  }
}
